// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".partner-logo-img[data-v-5cc83281]{max-width:8vw}@media (max-width:991.98px){.partner-logo-img[data-v-5cc83281]{max-width:40vw}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
